<template>
  <div>
    <LayoutContent>
      <SectionTitle :label="$t('label.reschedule')" />
      <ArrangeDelivery :isCheckout="false" />
    </LayoutContent>
    <bottom-bar>
      <v-container class="py-3 d-flex">
        <v-btn
          color="white"
          class="mx-auto px-10 d-block rounded-pill text-capitalize white--textfont-weight-medium"
          :class="{ 'primary--text text--darken-1': isValid === true }"
          @click="confirmDialog = true"
          :disabled="!isValid"
        >
          {{ $t('label.proceed') }}
        </v-btn>
      </v-container>
    </bottom-bar>
    <v-dialog content-class="elevation-0" v-model="confirmDialog" max-width="500">
      <v-card class="transparent elevation-0">
        <v-card-text class="pa-8 white elevation-3 rounded-lg">
          <p class="text-center font-weight-medium text-subtitle-1 px-12 py-16">{{ $t('label.areYouConfirmToReschedule') }}</p>
          <v-btn @click="confirmReschedule" color="primary" class="mx-auto px-10 d-block rounded-pill green-gradient-right text-capitalize">
            {{ $t('label.yesConfirm') }}
          </v-btn>
        </v-card-text>
        <v-card-actions class="transparent text-center">
          <v-btn color="transparent mx-auto" depressed fab @click="confirmDialog = false">
            <v-icon x-large class="transparent grey--text text--lighten-2">mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import LayoutContent from '@/views/layouts/LayoutContent'
import SectionTitle from '@/components/SectionTitle.vue'
import ArrangeDelivery from '@/components/checkout/ArrangeDelivery.vue'
export default {
  name: 'Delivery',
  components: {
    LayoutContent,
    SectionTitle,
    ArrangeDelivery
  },
  data: () => ({
    deliveryDate: '',
    deliveryTime: '',
    poNumber: '',
    confirmDialog: false
  }),
  computed: {
    ...mapState('auth', ['currentDeliveryAddress']),
    ...mapState('order', ['arrangeDelivery']),
    isValid() {
      return this.arrangeDelivery.date !== '' && this.arrangeDelivery.time !== '' && this.currentDeliveryAddress.id !== ''
    }
  },
  methods: {
    ...mapActions('order', ['rescheduleOrder']),
    async confirmReschedule() {
      await this.rescheduleOrder({ order_id: this.$route.params.id, date: this.arrangeDelivery.date, time: this.arrangeDelivery.time, delivery_address_id: this.currentDeliveryAddress.id })
        .then((res) => {
          this.$toast.success(res.message)
          this.$router.push({ name: 'order-detail', params: { poNumber: res.po_number } })
        })
        .catch((err) => {
          if (err.error_message === 'The order is not allowed to reschedule.') this.$toast.error(this.$t('error.orderNotAllowedToReschedule'))
        })
    }
  }
}
</script>
